import React, { Component } from 'react';
import LayoutMenu from '../components/index/LayoutMenu';
import { CommonDialog } from '../components/dialog/Dialog';
import { WebRTC } from '../utils/WebRTC';

import '../static/css/dialog.scss';
import '../static/css/device.css';

let recorder;
let st;
let maxVolumnTimer = null;
let volumn;

let hasDevice = true;

const DeviceDialog = ({ leftText, leftHandler, rightText, rightHandler, step }) => {
    return (
        <div className='dialog' style={{ background: 'rgba(0, 0, 0, .7)' }}>
            <div className='devide-dialog-container'>
                <div className='devide-dialog-avator' />
                <div className='devide-dialog-title'>
                    {step === 2 && (
                        <div>
                            请选择正确的
                            <span className='devide-dialog-tips'>麦克风</span>或<span className='devide-dialog-tips'>带麦克风的耳机</span>
                            ，并确认设备已启用
                        </div>
                    )}
                    {step === 3 && (
                        <div>
                            请选择正确的
                            <span className='devide-dialog-tips'>扬声器</span>或<span className='devide-dialog-tips'>耳机</span>
                            ，并确认设备已启用
                        </div>
                    )}
                    {step === 4 && (
                        <div>
                            请选择正确的
                            <span className='devide-dialog-tips'>摄像头</span>
                            ，并确认设备已启用
                        </div>
                    )}
                </div>
                <div className='devide-dialog-content'>
                    <div className='devide-dialog-content-issue' />
                    <div className='devide-dialog-content-title'>Windows系统；请逐一检查；</div>
                    {step === 2 ? (
                        <ul className='devide-dialog-content-list'>
                            <li>右下角系统任务栏，右键点击扬声器图标，选择【声音(S)】-录制，确认设备已启用且未静音；</li>
                            <li>进入系统"设备管理器"-"音频输入和输出"，右键启用正确的设备；</li>
                            <li>进入浏览器"内容设置"-"麦克风"，确认未禁止“putaoabc.com”</li>
                            <li>如您进入学习内容后有过插拔操作，请关闭后重启浏览器，再开始学习；</li>
                        </ul>
                    ) : (
                        ''
                    )}
                    {step === 3 ? (
                        <ul className='devide-dialog-content-list'>
                            <li>右下角任务栏，点击扬声器图标，确认未静音，调整至合适音量；</li>
                            <li>右键点击扬声器图标，【打开音量混合器】，调整浏览器音量；</li>
                            <li>右键点击扬声器图标，点击【声音(S)】-播放，确认设备已启用；</li>
                            <li>进入系统"设备管理器"-"声音、视频和游戏控制器"，右键启用设备；</li>
                            <li>进入浏览器"内容设置"-"声音"，确认未禁止“putaoabc.com”</li>
                        </ul>
                    ) : (
                        ''
                    )}
                    {step === 4 ? (
                        <ul className='devide-dialog-content-list'>
                            <li>进入系统"设备管理器"-"照相机"(或"图像设备")，右键启用正确的设备；</li>
                            <li>进入浏览器"内容设置"-"摄像头"，确认未禁止“putaoabc.com”</li>
                        </ul>
                    ) : (
                        ''
                    )}
                </div>
                <div className='devide-dialog-issue-statement'>
                    更详细说明请点击查看{' '}
                    <span
                        className='devide-dialog-issue-statement-tips'
                        onClick={() => {
                            window.open('https://download-1256571289.cos.ap-beijing.myqcloud.com/Documents/instructions.pdf');
                        }}
                    >
                        【常见问题说明】
                    </span>
                </div>
                <div className='devide-dialog-button'>
                    <div className='devide-dialog-button-cancle' onClick={() => leftHandler()}>
                        {leftText}
                    </div>
                    <div className='devide-dialog-button-sure' onClick={() => rightHandler()}>
                        {rightText}
                    </div>
                </div>
            </div>
        </div>
    );
};

class Device extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            networkStatus: 0, //网络检测状态：0-未开始；1-开始进行中；2-测试完成
            test: [],
            start: false,
            hasAudioError: false,
            hasVedioError: false,
            showDenied: false,
            showWeixin: false,
            update: false,
        };

        this.handleTestFail = this.handleTestFail.bind(this);
        this.handleTestPass = this.handleTestPass.bind(this);
        this.reAuthorizeHandler = this.reAuthorizeHandler.bind(this);
        this.audioSourseRefreshHandler = this.audioSourseRefreshHandler.bind(this);
    }

    componentDidMount() { }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        const { step, update } = this.state;

        if (step > 1) {
            //兼容
            window.URL = window.URL || window.webkitURL;
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

            var videoElement = document.getElementById('webcam');
            // var audioElement = document.getElementById("playDeviceAudio");
            var audioSelect = document.querySelector('select#audioSource');
            var videoSelect = document.querySelector('select#videoSource');

            var audioOutput = document.querySelector('select#audioOutput');

            // if(prevState.step === step) {
            //   audioSelect && audioSelect.remove();
            //   videoSelect && videoSelect.remove();
            //   audioOutput && audioOutput.remove();
            // }
            if (prevState.step !== step || update) {
                // if (step === 3) {
                //   navigator.mediaDevices
                //     .enumerateDevices()
                //     .then(getStream)
                //     .catch(handleError);
                // } else {
                if (navigator && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                    navigator.mediaDevices
                        .enumerateDevices()
                        .then(gotDevices)
                        .then(getStream)
                        .catch(handleError);
                }
            }
            // else if (update) {
            //   navigator.mediaDevices
            //     .enumerateDevices()
            //     .then(gotDevices)
            //     .then(getStream)
            //     .catch(handleError);
            // }

            if (audioOutput) {
                audioOutput.onchange = getStream;
            }
            if (videoSelect) {
                videoSelect.onchange = getStream;
            }
            if (audioSelect) {
                audioSelect.onchange = getStream;
            }

            function gotDevices(deviceInfos) {
                // 是否可以在这里判断有没有设备，如果没有的话，就弹框结束设备检测
                const deviceKind = deviceInfos.map(value => {
                    return value.kind;
                });

                // hasDevice = deviceKind.find(value => value === 'videoinput') && deviceKind.find(value => value === 'audioinput');
                hasDevice = deviceKind.find(value => value === 'videoinput') || deviceKind.find(value => value === 'audioinput');

                for (var i = 0; i !== deviceInfos.length; ++i) {
                    var deviceInfo = deviceInfos[i];
                    var option = document.createElement('option');
                    option.value = deviceInfo.deviceId;
                    //   默认选中
                    option.selected = 'selected';
                    if (deviceInfo.kind === 'audioinput' && audioSelect) {
                        option.text = deviceInfo.label || 'microphone ' + (audioSelect.length + 1);
                        audioSelect.appendChild(option);
                    } else if (deviceInfo.kind === 'videoinput' && videoSelect) {
                        option.text = deviceInfo.label || 'camera ' + (videoSelect.length + 1);
                        videoSelect.appendChild(option);
                    } else if (deviceInfo.kind === 'audiooutput' && audioOutput) {
                        option.text = deviceInfo.label || 'camera ' + (videoSelect.length + 1);
                        audioOutput.appendChild(option);
                    } else {
                        console.log('Found one other kind of source/device: ', deviceInfo);
                    }
                }
            }

            function getStream() {
                if (window.stream) {
                    window.stream.getTracks().forEach(function (track) {
                        track.stop();
                    });
                }
                var constraints = {};
                if (videoSelect) {
                    constraints = {};
                    constraints = {
                        video: {
                            deviceId: { exact: videoSelect && videoSelect.value },
                        },
                    };
                } else {
                    constraints = {};
                    constraints = {
                        audio: {
                            deviceId: {
                                exact: audioSelect ? audioSelect.value : audioOutput.value,
                            },
                        },
                    };
                }

                if (!videoSelect && !audioSelect) {
                    constraints = {};
                }

                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(gotStream)
                    .catch(handleError);
            }

            function gotStream(stream) {
                window.stream = stream; // make stream available to console
                if (videoElement) {
                    videoElement.srcObject = stream;
                }
            }

            function handleError(error) {
                if (error.name === 'NotAllowedError' || error.name === 'Permission denied') {
                    that.setState({ showDenied: true });
                }
                if (videoSelect) {
                    that.setState({
                        hasVedioError: true
                    });
                } else if (step === 2) {
                    that.setState({
                        hasAudioError: true
                    });
                }
            }

            if (step === 2) {
                that.startRecording();
            } else if (step === 3 && prevState.step !== step) {
                that.playRecord();
            }
            if (step === 4) {
                // document.getElementById("playDeviceAudio").src = "";
                document.getElementById('playDeviceAudio').pause();
            }
        }

        if (this.state.networkStatus === 1) {
            that.showLoadCircle();
        }
    }

    componentWillUnmount() {
        clearInterval(maxVolumnTimer);
        clearTimeout(this.timerOut);
    }

    audioSourseRefreshHandler() {
        var audioSelect = document.querySelector('select#audioSource');
        var videoSelect = document.querySelector('select#videoSource');

        var audioOutput = document.querySelector('select#audioOutput');
        if (audioSelect) {
            audioSelect.innerHTML = '<option disabled="disabled">请选择麦克风设备</option>';
        }
        if (videoSelect) {
            videoSelect.innerHTML = '<option disabled="disabled">请选择摄像头设备</option>';
        }
        if (audioOutput) {
            audioOutput.innerHTML = '<option disabled="disabled">请选择播放设备</option>';
        }

        this.reAuthorizeHandler();
    }

    // 重新获取授权
    reAuthorizeHandler() {
        this.setState({ update: true });

        this.timerOut = setTimeout(() => {
            this.setState({ update: false });
        }, 500);
    }

    //检测相关方法
    handleTestPass(stepValue, flag) {
        const that = this;
        const { step, test, networkStatus } = this.state;
        if (stepValue) {
            test[step - 1] = true;
        } else if (networkStatus === 3) {
            test[step - 1] = false;
        } else if (networkStatus === 2) {
            console.log(networkStatus);
            test[step - 1] = true;
        }
        // if (flag) {
        //   that.setState({
        //     step: step,
        //     test: test
        //   });
        //   return null;
        // }
        that.setState(
            {
                step: step + 1,
                test: test,
            },
            () => {
                if (step === 2) {
                    that.stopRecord();
                }
            }
        );
        if (step < 4 && step >= 1) {
            this.setState({ disabled: true });
            this.timer = setTimeout(() => {
                this.setState({
                    disabled: false,
                });
            }, 2000);
        }
    }

    handleTestFail(stepValue) {
        const that = this;
        const { step, test } = this.state;

        this.setState({ hasAudioError: false, hasVedioError: false });
        if (stepValue) {
            test[step - 1] = false;
        }
        that.setState({
            step: step + 1,
            test: test,
        });
    }

    handleTestAgain(stepValue) {
        const that = this;
        const { step } = this.state;
        this.setState({ hasAudioError: false, hasVedioError: false });

        that.setState({
            step: step,
        });
    }

    handleNetworkTest() {
        this.setState(
            {
                networkStatus: 1,
            },
            () => {
                st = new Date();
            }
        );
    }

    showLoadCircle() {
        // 在这里写加载的逻辑
        var leftContent = document.getElementById('left-content');
        var rightContent = document.getElementById('right-content');
        var textCircle = document.getElementById('text-circle');

        // 先是 leftContent 从 0 旋转到 180 度，然后是 rightContent 从 0 旋转到 180
        var angle = 0;
        var timerId = setInterval(() => {
            angle += 1;
            if (angle > 360) {
                clearInterval(timerId);
                this.showNetworkSpeed();
            } else {
                if (angle > 180) {
                    rightContent.style.transform = `rotate(-${angle - 180}deg)`;
                    // rightContent.setAttribute('style', `transfrom: rotate(${angle-180}deg)`);
                } else {
                    leftContent.style.transform = `rotate(-${angle}deg)`;
                    // leftContent.setAttribute('style', `transfrom: rotate(${angle}deg)`);
                }

                textCircle.innerHTML = `${parseInt((angle * 100) / 360, 10)}%`;
            }
        }, 10);
    }

    showNetworkSpeed() {
        const { test, networkStatus } = this.state;
        if (networkStatus === 3) {
            return;
        }
        let filesize = 1285185; //measured in bytes
        let et = new Date();
        let speed = Math.round(filesize) / (et - st);
        let scope = speed > 0 && speed <= 50 ? 0 : speed > 50 && speed <= 100 ? 1 : speed >= 100 && speed < 200 ? 2 : speed >= 200 && speed < 300 ? 3 : 4;
        test[0] = scope;
        if (scope > 0) {
            this.setState({
                networkStatus: 2,
                test: test,
            });

            console.log('-======', scope);
        }
    }

    //  没网
    onLoadError() {
        this.setState({
            networkStatus: 3,
        });
    }

    //录音相关方法
    startRecording() {
        WebRTC.getHZRecorder(function (rec) {
            recorder = rec;
            recorder.start();
        });

        // 开始录音之后，隔一会就更新当前的最大值
        maxVolumnTimer = setInterval(() => {
            volumn = Math.floor((window.maxVolumn / 1.5) * 17);
            // document.getElementById("volumeNum").innerText = volumn;
            let Li = '';
            for (let i = 1; i < volumn; i++) {
                Li += '<li class="volumn-active" }} />';
            }
            const volumeUL = document.getElementById('top');
            if (volumeUL) {
                volumeUL.innerHTML = `<ul>${Li}</ul>`;
            }
        }, 100);
    }

    obtainRecord() {
        let record = recorder.getBlob();
        console.log(record);
        //debugger;
    }

    stopRecord() {
        if (recorder) {
            recorder.stop();
        }
        clearInterval(maxVolumnTimer);
        console.log('停止录音');
    }

    playRecord() {
        console.log(recorder);
        if (hasDevice) {
            // recorder.play(document.getElementById("playDeviceAudio"));
            const audio = document.getElementById('playDeviceAudio');
            audio.load();
            audio.play();
        }
    }

    startTest() {
        this.setState({ start: true });
        this.handleNetworkTest();
    }

    // 完成检测
    successDeviceTest() {
        window.localStorage.setItem('isTest', true);
        window.location.href = `${window.location.pathname}${window.location.search}`;
    }

    // 重新检测
    againDeviceTest() {
        this.setState({ step: 1, networkStatus: 0, test: [] });
        this.startTest();
        window.localStorage.setItem('isTest', true);
    }

    render() {
        let that = this;
        let { step, networkStatus, test, start, disabled, hasAudioError, hasVedioError, showDenied, showWeixin } = this.state;
        // let arr = [
        //   "网速低于50KB",
        //   "网速在50-100KB之间",
        //   "网速在100-200KB之间",
        //   "网速在200-300KB之间",
        //   "网速可以进行视频通讯"
        // ];
        // let arr2 = ["较差", "一般", "良好", "较好", "非常棒"];
        console.log(test);

        return (
            <LayoutMenu page='device' showInfo={false} showFM={false}>
                <div
                    className='go-back'
                    onClick={() => {
                        window.history.go(-1);
                    }}
                />
                <div className='device-container'>
                    {!start && hasDevice && (
                        <div className='test-intro'>
                            <div className='device-title'>设备检测</div>
                            <div className='intro-container'>
                                <div className='intro-content'>
                                    <div className='network-logo' />
                                    <div className='intro-name'>网络情况</div>
                                    <div className='intro-description'>检查网络连接情况，让宝贝享受良好的学习效果</div>
                                </div>
                                <div className='intro-content'>
                                    <div className='audio-logo' />
                                    <div className='intro-name'>麦克风</div>
                                    <div className='intro-description'>通过声音播放收听老师的精彩讲解，找到适合宝贝的音量大小</div>
                                </div>
                                <div className='intro-content'>
                                    <div className='sound-logo' />
                                    <div className='intro-name'>声音播放</div>
                                    <div className='intro-description'>通过麦克风与老师进行语音互动，帮助宝贝锻炼英语发音能力</div>
                                </div>

                                <div className='intro-content'>
                                    <div className='video-logo' />
                                    <div className='intro-name'>摄像头</div>
                                    <div className='intro-description'>通过摄像头记录宝贝学习精彩瞬间，第一时间了解宝贝的学习情况</div>
                                </div>
                            </div>
                            <button
                                className='test-start'
                                onClick={() => {
                                    that.startTest();
                                }}
                            >
                                开始检测
                            </button>
                        </div>
                    )}
                    {start && hasDevice && (
                        <div id='device'>
                            {step !== 5 && (
                                <ol className='device-step'>
                                    <li className={step === 1 ? 'on' : ''}>网络检测</li>
                                    <li className={step === 2 ? 'on' : ''}>麦克风</li>
                                    <li className={step === 3 ? 'on' : ''}>声音播放</li>
                                    <li className={step === 4 ? 'on' : ''}>摄像头</li>
                                </ol>
                            )}

                            {step === 1 ? (
                                <div className='device-test'>
                                    {networkStatus === 0 ? (
                                        <a
                                            className='btn not'
                                            onClick={() => {
                                                that.handleNetworkTest();
                                            }}
                                        >
                                            开始检测
                                        </a>
                                    ) : networkStatus === 1 ? (
                                        <div>
                                            <img
                                                alt='测试图片'
                                                style={{ height: 0 }}
                                                src={'https://www.putaoabc.com/onlinepages/course_h5/class_report/images/preview_bg.png?_t=' + Math.random()}
                                                onError={() => {
                                                    this.onLoadError();
                                                }}
                                            // onLoad={() => {}}
                                            />
                                            <div className='load-contianer'>
                                                <div className='percent-circle percent-circle-left'>
                                                    <div className='left-content' id='left-content' />
                                                </div>
                                                <div className='percent-circle percent-circle-right'>
                                                    <div className='right-content' id='right-content' />
                                                </div>
                                                <div className='text-circle' id='text-circle'>
                                                    0%
                                                </div>
                                            </div>
                                            <div className='testing'>检测中...</div>
                                        </div>
                                    ) : networkStatus === 2 ? (
                                        test[0] <= 2 ? (
                                            <div>
                                                <div className='not-good-network' />
                                                <div className='network-text'>网络欠佳</div>
                                                <div className='network-tips'>
                                                    现在学习可能会出现卡顿，
                                                    <br />
                                                    建议您切换网络，或换个时间学习
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                                <div className='good-network' />
                                                <div className='network-text'>网络状况良好</div>
                                            </div>
                                        )
                                    ) : networkStatus === 3 ? (
                                        <div>
                                            <div className='no-network' />
                                            <div className='network-text'>无法连接网络</div>
                                            <div className='network-tips'>请检查您的网络设备后重试</div>
                                        </div>
                                    ) : null}
                                </div>
                            ) : step === 2 ? (
                                <div className='device-test'>
                                    <div className='select'>
                                        {/* <label htmlFor="audioSource">Audio source: </label> */}
                                        <div className='select-container lighter'>
                                            <select id='audioSource' className='audioSource' key={step}>
                                                <option disabled='disabled'>请选择麦克风设备</option>
                                            </select>
                                            <div
                                                onClick={() => {
                                                    this.audioSourseRefreshHandler();
                                                }}
                                                className='audioSource-refresh'
                                            />
                                        </div>
                                        <div className='audio-tips'>
                                            请选择正确的
                                            <span className='audio-tips-name'>麦克风</span>或<span className='audio-tips-name'>带麦克风的耳机</span>
                                            ，确认设备已启用
                                        </div>
                                    </div>
                                    <div className='audio-volumn-container'>
                                        <div className='audio-volumn-logo' />
                                        <div className='audio-volumn'>
                                            <div className='backgroud'>
                                                <ul>
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                    <li />
                                                </ul>
                                            </div>
                                            <div className='top' id='top' />
                                        </div>
                                    </div>
                                    <div className='microphone-audio-hint'>
                                        <p>
                                            请大声朗读：
                                            <span className='audio-tips-name'>步步ABC，快乐学英语！</span>
                                            <span id='volumeNum' />
                                        </p>
                                    </div>
                                    <div className='audio-taotao-container'>
                                        <div className='audio-taotao' />
                                        <div className='taotao-dialog'>您是否能看到声音条跳动 听到自己的说话声？</div>
                                    </div>
                                </div>
                            ) : step === 3 ? (
                                <div className='device-test'>
                                    {/* 与上面麦克风检测部分相同 */}
                                    <div className='select'>
                                        <div className='select-container lighter'>
                                            <select id='audioOutput' className='audioSource' name='audioOutput' key={step}>
                                                <option disabled='disabled'>请选择播放设备</option>
                                            </select>
                                            <div
                                                onClick={() => {
                                                    this.audioSourseRefreshHandler();
                                                }}
                                                className='audioSource-refresh'
                                            />
                                        </div>
                                        <div className='audio-tips'>
                                            请选择正确的
                                            <span className='audio-tips-name'>扬声器</span>或<span className='audio-tips-name'>耳机</span>
                                            ，确认设备已启用
                                        </div>
                                    </div>
                                    <div className='sound-logo-content' />
                                    <div className='sound-logo-content-text'>试听声音</div>
                                    <div className='audio-taotao-container'>
                                        <div className='audio-taotao sound-taotao' />
                                        <div className='taotao-dialog' style={{ lineHeight: '40px' }}>
                                            您是否能清晰的听到声音
                                        </div>
                                    </div>
                                </div>
                            ) : step === 4 ? (
                                <div className='device-test'>
                                    {/* 这里与 audio 部分共用样式 */}
                                    <div className='select'>
                                        <div className='select-container lighter'>
                                            <select id='videoSource' className='audioSource' name='vedio' key={step}>
                                                <option disabled='disabled'>请选择摄像头设备</option>
                                            </select>
                                            <div
                                                onClick={() => {
                                                    this.audioSourseRefreshHandler();
                                                }}
                                                className='audioSource-refresh'
                                            />
                                        </div>
                                        <div className='audio-tips'>
                                            请将
                                            <span className='audio-tips-name'>摄像头</span>
                                            对准自己，保持头部出现在画面中
                                        </div>
                                    </div>
                                    <div>
                                        <video id='webcam' width='220' height='128' style={{ borderRadius: '10px' }} muted autoPlay />
                                    </div>
                                    <div className='audio-taotao-container'>
                                        <div className='audio-taotao video-taotao' />
                                        <div className='taotao-dialog' style={{ lineHeight: '40px' }}>
                                            您是否能清晰的看到自己
                                        </div>
                                    </div>
                                </div>
                            ) : step === 5 ? (
                                Array.isArray(test) &&
                                    test.every(value => {
                                        return value === true;
                                    }) ? (
                                    <div className='device-test'>
                                        <div className='pass-test'>恭喜您，设备检测正常！</div>
                                        <div className='pass-test-logo' />
                                        <div className='pass-test-text'>可以学习啦！</div>
                                        <div className='pass-test-text'>请准备安静的学习环境哦~</div>
                                    </div>
                                ) : (
                                    <div className='device-test'>
                                        <div className='fail-test'>很遗憾！设备检测未通过！</div>
                                        <table className='fail-test-tabel'>
                                            <tr>
                                                <td>网络</td>
                                                <td>麦克风</td>
                                                <td>声音播放</td>
                                                <td>摄像头</td>
                                            </tr>
                                            <tr>
                                                <td>{test[0] === true ? '优' : <span className='test-error-text'>异常</span>}</td>
                                                <td>{test[1] === true ? '优' : <span className='test-error-text'>异常</span>}</td>
                                                <td>{test[2] === true ? '优' : <span className='test-error-text'>异常</span>}</td>
                                                <td>{test[3] === true ? '优' : <span className='test-error-text'>异常</span>}</td>
                                            </tr>
                                        </table>
                                        <div className='fail-test-intro-container'>
                                            <div className='fail-test-intro-logo' />
                                            <ul className='fail-test-intro-content'>
                                                <li>
                                                    <p className='fail-test-intro-content-title'>麦克风问题</p>
                                                    <p>确认电脑设备已启用麦克风，并检查声音播放确认再浏览器中，已允许步步ABC访问麦克风；</p>
                                                </li>
                                                <li>
                                                    <p className='fail-test-intro-content-title'>声音播放问题</p>
                                                    <p>确认电脑及浏览器均非静音，并调整至合适音量，如使用耳机播放，请重新插拔耳机再试一下；</p>
                                                </li>

                                                <li>
                                                    <p className='fail-test-intro-content-title'>摄像头问题</p>
                                                    <p>确认电脑设备已启用摄像头，保证环境光线充足请将摄像头对准自己，擦拭并避免异物遮挡。</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className='fail-test-statement'>
                                            更多问题详见：
                                            <span
                                                className='fail-test-statement-link'
                                                onClick={() => {
                                                    window.open('https://download-1256571289.cos.ap-beijing.myqcloud.com/Documents/instructions.pdf');
                                                }}
                                            >
                                                常见问题说明
                                            </span>{' '}
                                                或微信联系我们：
                                            <span
                                                className='fail-test-statement-link'
                                                onClick={() => {
                                                    this.setState({
                                                        showWeixin: true,
                                                    });
                                                }}
                                            >
                                                查看微信
                                            </span>
                                        </div>
                                    </div>
                                )
                            ) : null}
                            <div className='button-container'>
                                <button
                                    className='again'
                                    disabled={networkStatus === 1 ? true : disabled}
                                    style={{
                                        cursor: disabled || networkStatus === 1 ? 'default' : 'pointer',
                                    }}
                                    onClick={() => {
                                        step === 1
                                            ? this.startTest()
                                            : step === 5
                                                ? this.againDeviceTest()
                                                : step === 4
                                                    ? this.setState({ hasVedioError: true })
                                                    : this.setState({ hasAudioError: true });
                                    }}
                                >
                                    {step === 1 ? '重新检测' : step === 5 ? '重新检测' : '不能'}
                                </button>
                                <button
                                    className={disabled || networkStatus === 1 ? 'next into-gray' : 'next'}
                                    disabled={networkStatus === 1 ? true : disabled}
                                    style={{
                                        cursor: disabled || networkStatus === 1 ? 'default' : 'pointer',
                                    }}
                                    // disabled={disabled}
                                    onClick={() => {
                                        step === 1 ? this.handleTestPass() : step === 5 ? this.successDeviceTest() : this.handleTestPass(step);
                                    }}
                                >
                                    {step === 1 ? '下一步' : step === 5 ? '完成检测' : '能'}
                                </button>
                            </div>
                        </div>
                    )}

                    <div className='audioOpare hide' style={{ position: 'fixed', bottom: 0 }}>
                        <audio
                            id='playDeviceAudio'
                            src='https://course-app-1256571289.cos.ap-beijing.myqcloud.com/songs/audio/level1/43e208fcc81cba9e.mp3'
                            // autoPlay
                            loop='loop'
                        />
                        {/* <input
              type="button"
              value="开始录音"
              onClick={() => that.startRecording()}
            />
            <input
              type="button"
              value="获取录音"
              onClick={() => that.obtainRecord()}
            />
            <input
              type="button"
              value="停止录音"
              onClick={() => that.stopRecord()}
            />
            <input
              type="button"
              value="播放录音"
              onClick={() => that.playRecord()}
            />
            <input type="text" x-webkit-speech="true" /> */}
                    </div>
                </div>
                <div className='bottom-background' />
                <div className='pipeline' />
                <div className='ladder' />
                <div className='screwdriver' />
                <div className='roadblock' />
                {!hasDevice && (
                    <DeviceDialog
                        leftText='知道了'
                        leftHandler={() => (window.location.href = window.publicUrl + `${window.location.pathname}${window.location.search}#/`)}
                        rightText='设备检测'
                        rightHandler={() => window.location.reload(true)}
                        step={step}
                    />
                )}

                {hasAudioError && (
                    <DeviceDialog
                        leftText='重新检测'
                        leftHandler={() => this.handleTestAgain(step)}
                        rightText='下一步'
                        rightHandler={() => {
                            this.setState({ hasAudioError: false });
                            this.handleTestFail(step);
                        }}
                        step={step}
                    />
                )}
                {hasVedioError && (
                    <DeviceDialog
                        leftText='重新检测'
                        leftHandler={() => this.handleTestAgain(step)}
                        rightText='下一步'
                        rightHandler={() => {
                            this.setState({ hasVedioError: false });
                            this.handleTestFail(step);
                        }}
                        step={step}
                    />
                )}
                {!hasVedioError && showDenied && (
                    <CommonDialog
                        title='警告提示'
                        text='您有设备被禁止使用，为了宝贝能正常学习，请允许访问摄像头、麦克风。点击浏览器地址栏右侧摄像头图标，修改为允许使用。其他问题请查看：'
                        otherText='【常见问题说明】'
                        otherHref='https://download-1256571289.cos.ap-beijing.myqcloud.com/Documents/instructions.pdf'
                        hasClose={true}
                        cancleText='关闭'
                        cancleHandler={() => {
                            this.setState({ showDenied: false });
                            window.location.reload();
                        }}
                        sureText='好了'
                        sureHanlder={() => {
                            this.setState({ showDenied: false });
                            this.audioSourseRefreshHandler();
                        }}
                    />
                )}
                {showWeixin && (
                    <div
                        className='show-weixin'
                        onClick={() => {
                            this.setState({ showWeixin: false });
                        }}
                    >
                        <div className='weixin-code' />
                    </div>
                )}
            </LayoutMenu>
        );
    }
}

export default Device;



// WEBPACK FOOTER //
// ./src/route/Device.js